import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconLink = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 12"
    aria-label="IconLink"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M10.805 11.908H6.003a6.02 6.02 0 0 1-4.245-1.744 5.92 5.92 0 0 1 0-8.42A6.03 6.03 0 0 1 6.003 0h4.802v2.382H6.003a3.61 3.61 0 0 0-2.546 1.046 3.55 3.55 0 0 0 0 5.052 3.62 3.62 0 0 0 2.546 1.047h4.802zM18.007 0h-4.802v2.382h4.794a3.61 3.61 0 0 1 2.546 1.046 3.55 3.55 0 0 1 0 5.052A3.62 3.62 0 0 1 18 9.527h-4.802v2.381H18a6.03 6.03 0 0 0 4.245-1.744 5.924 5.924 0 0 0 0-8.42A6.03 6.03 0 0 0 17.999 0m-1.2 4.764H7.197v2.38h9.602z" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconLink);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
